import { LogoutIcon, QuestionMarkCircleIcon, TagIcon, UsersIcon } from "@heroicons/react/outline";
import { Menu, Tooltip } from "@mui/material";
import { useState } from "react";
import { Check2, ChevronDown, ChevronUp, Wifi, WifiOff } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import NO_PHOTO from "../assets/nophoto.png";
import logo from "../assets/pos-logo.svg";
import ConfirmationPopUp from "../Controllers/ConfirmationPopUp";
import Popup from "../Controllers/Popup";
import { logOut, selectLocation } from "../Redux/Action/auth.action";
const Sidebar = () => {
  const dispatch = useDispatch();
  const { locations, staffInfo } = useSelector((state) => state.authReducer);
  const [isClose, setIsClose] = useState(false);
  const [storeToggle, setstoreToggle] = useState(false);
  const [anchorEl, setAnchorEl] = useState(false);
  const location = useLocation();
  const location_id = localStorage.getItem("location_id");
  const locationName = locations?.find((location) => location._id === location_id)?.name ?? "";
  const closePopup = () => {
    setIsClose(false);
  };
  const signOut = () => {
    dispatch(logOut());
  };
  const dataLocation =
    staffInfo?.pos_location_info?.length > 0
      ? locations?.filter((loc) => staffInfo.pos_location_info.includes(loc._id))
      : locations; // 🔥 show all

  return (
    <>
      <div className="xl:block hidden mx-auto">
        <img src={logo || NO_PHOTO} alt={logo} className="block mx-auto" />
      </div>
      <div className="block xl:hidden mx-auto">
        <img src={logo} alt={logo} className="block mx-auto" />
      </div>
      <p className="flex justify-center items-center mt-2 font-medium text-xs">
        {locationName && (
          <Tooltip title="Change Location">
            <button
              id="store-menu"
              className="flex-1 justify-between active text-primary sm:px-1 transition-all duration-300 sm:py-1 sm:pe-2 rounded-[6px] text-sm flex items-center"
              onClick={(e) => {
                setAnchorEl(e.currentTarget);
                setstoreToggle(true);
              }}
            >
              <div className="flex items-center">
                <div className="w-[28px] h-[28px] rounded-[6px] me-2 flex items-center font-medium capitalize justify-center bg-primary text-white">
                  {locationName?.charAt(0)}
                </div>
                {/* <div className='w-[10px] h-[10px] me-1 sm:me-2 bg-[#238823] rounded-full'></div> */}
                <div className="block me-1 font-semibold capitalize">{locationName}</div>
                {storeToggle ? <ChevronUp /> : <ChevronDown />}
              </div>
            </button>
          </Tooltip>
        )}
        <div className="flex items-center">
          <span
            className={`flex items-center ${navigator.onLine ? "success-text" : "error-text"} w-4 h-5`}
          >
            {navigator.onLine ? <Wifi /> : <WifiOff />}
          </span>
          <span
            className={`flex items-center ${navigator.onLine ? "success-text" : "error-text"} font-normal`}
          >
            {navigator.onLine ? "Online" : "Offline"}
          </span>
        </div>
      </p>
      <ul className="mt-5">
        <Link
          to="/cashier"
          className={`menu-item gap-2 ${location.pathname.includes("cashier") && "active"}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z"
            />
          </svg>
          <span>Cashier</span>
        </Link>
        <Link
          to="/transaction"
          className={`menu-item gap-2 ${location.pathname.includes("transaction") && "active"}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
            />
          </svg>

          <span>Transactions</span>
        </Link>
        <Link
          to="/products"
          className={`menu-item gap-2 ${location.pathname.includes("products") && "active"}`}
        >
          <TagIcon className="w-[18px] h-[18px]" />
          <span>Product List</span>
        </Link>
        <Link
          to="/customers"
          className={`menu-item gap-2 ${location.pathname.includes("customers") && "active"}`}
        >
          <UsersIcon className="w-[18px] h-[18px]" />
          <span>Customers List</span>
        </Link>
        {/* <li className={`menu-item gap-2`}>
                    <FlagIcon className='w-5 h-5' />
                    <span>Analytics</span>
                </li> */}
        {/* <li className={`menu-item gap-2`}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                    <span>Setting</span>
                </li> */}
        <li
          className={`menu-item gap-2`}
          onClick={() => window.open("https://docs.shopeasy.ai/", "_blank")}
        >
          <QuestionMarkCircleIcon className="w-5 h-5" />
          <span>Help & Support</span>
        </li>
        <li className={`menu-item gap-2`} onClick={() => setIsClose(true)}>
          <LogoutIcon className="w-5 h-5 text-red-500" />
          <span className="text-red-500">logout</span>
        </li>
      </ul>
      <Menu
        id={"store-menu"}
        open={storeToggle}
        anchorEl={anchorEl}
        onClose={() => setstoreToggle(!storeToggle)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        className="mt-2"
      >
        <div className="space-y-1 px-1.5 secondary-bg-color w-56 text-left rounded-[6px] primary-bg-color focus:outline-none">
          {dataLocation?.map((elem, index) => {
            return (
              <div
                key={index}
                className={`rounded-[6px] text-sm cursor-pointer py-1 px-2 min-w-[150px] flex items-center justify-between ${location_id === elem?._id ? "bg-secondary text-primary" : ""}`}
                onClick={() => {
                  dispatch(selectLocation({ location_id: elem?._id }));
                }}
              >
                <div className="flex items-center">
                  <div
                    className={`w-7 h-7 rounded-[6px] me-2 flex items-center font-medium capitalize justify-center ${location_id === elem?._id ? "bg-primary text-white" : "bg-secondary"}`}
                  >
                    {elem?.name?.charAt(0)}
                  </div>
                  <div className="">{elem?.name}</div>
                </div>
                {location_id == elem?._id && <Check2 className="text-primary" />}
              </div>
            );
          })}
          <div></div>
        </div>
      </Menu>
      <Popup
        showPopup={isClose}
        closePopup={closePopup}
        callComponant={
          <ConfirmationPopUp
            heading="Logout"
            subHeading="Are you sure you want to logout ?"
            runFunction={signOut}
            closePopup={closePopup}
            logout={true}
          />
        }
        closebtn={true}
      />
    </>
  );
};

export default Sidebar;
